import { getSaltusOwners } from '../../graphql/queries';
import {
  GET_SALTUSOWNERS_REQUESTED,
  GET_SALTUSOWNERS_COMPLETED,
  GET_SALTUSOWNERS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const getSaltusOwnerAction = () => async (dispatch, getState) => {
  const { contacts } = getState();
  const contact = contacts.get('set');
  const ContactID = contact?.ContactID ?? null;
  dispatch({
    type: GET_SALTUSOWNERS_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: getSaltusOwners,
      variables: {
        ContactID,
      },
    });

    dispatch({
      type: GET_SALTUSOWNERS_COMPLETED,
      payload: data.getSaltusOwners,
    });
  } catch (err) {
    debug(GET_SALTUSOWNERS_FAILED, err);

    dispatch({
      type: GET_SALTUSOWNERS_FAILED,
      payload: err,
    });
  }
};

export default getSaltusOwnerAction;
